import {GtmAbstractService} from './services/gtm.abstract.service';
import {injectGtmService} from "./utils/gtm.util";
import {PageTimeSpentDataLayerModel} from "./models/page-time-spent.data-layer.model";

// TODO: Extending classes doesn't feel right, 
export abstract class GtmSupportAbstractComponent {
	
	protected readonly gtmService: GtmAbstractService;
	private counterStarted = false;
	private startTime = 0;

	protected constructor(gtmConfig: any) {
		this.gtmService = injectGtmService(gtmConfig);
	}

	// To be added in ngOnInit method
	protected startPageTimer(): void {
		this.startTime = performance.now();
		this.counterStarted = true;
	}

	// To be added in ngOnDestroy
	protected sendPageTimeSpentEvent(): void {
		if (this.counterStarted) {
			const endTime = performance.now();
			const timeSpent = endTime - this.startTime;
			const timeSpentInSeconds = Math.floor(timeSpent / 1000);
			this.gtmService.pushEventToDataLayer(new PageTimeSpentDataLayerModel(timeSpentInSeconds));
			this.counterStarted = false;
		}
	}
}